import * as S from "./alarmPageConent.styles";
import { AlarmContentItem } from "../../molcules/AlarmContentItem";
interface AlarmPageContentProps {}

export const AlarmPageContent = ({}: AlarmPageContentProps) => {
  const dummydata = [
    {
      header: "운송기사 등록완료",
      date: "2022-08-16 15:32:32",
      content: "운송기사 등록이 완료되었습니다.",
    },
    {
      header: "운송기사 등록완료",
      date: "2022-08-16 15:32:32",
      content:
        "호랑이얼굴 님으로부터 배차가 등록되었습니다. 배차 정보를 확인해 주세요.",
    },
    {
      header: "운송기사 등록완료",
      date: "2022-08-16 15:32:32",
      content:
        "운송번호 A107-582037의 배차를 운송 수락하셨습니다. 운송을 시작합니다.",
    },
  ];

  return (
    <S.MainContentsSection>
      <S.MainContentsList>
        <AlarmContentItem dummydata={dummydata} />
      </S.MainContentsList>
    </S.MainContentsSection>
  );
};
